import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import {CircularProgress, makeStyles} from "@material-ui/core";
import RowRadioButtonsGroup from "./RadioButtonComponent";
import { useNavigate } from "react-router-dom";


const steps = [
    {
        label: 'Choose Category',
        options: ['nacte', 'Cambridge', 'bre']

    },
    {
        label: 'Course',
        options:
            ['maths', 'economics', 'computer'],
    },
    {
        label: 'level',
        options: ['beginner', 'intermediate', 'advanced'],
    },
];

export default function VerticalLinearStepper({style}) {
    let navigate = useNavigate();

    const [activeStep, setActiveStep] = React.useState(0);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    if (activeStep === steps.length) {
        setTimeout(() => {
            console.log('navigating to tutors cards, to mimic the fetching!')
            navigate('/tutors')
        }, 3000);
    }

    const useStyles = makeStyles(() => ({
        root: {
            '& .MuiStepIcon-root': {fontSize: 32},
            '& .MuiStepIcon-text': {fontSize: 12},
            '& .MuiStepIcon-root.Mui-active': {color: '#DE5103'},
            '& .MuiStepIcon-root.Mui-completed': {color: '#DE5103'},
            '& .MuiStepLabel-label': {fontSize: 14},
        }
    }))
    const useStyleObject = useStyles();

    return (
        <Box sx={{ width: '100%', display: {xs: 'block', sm: 'none', md: 'none', lg: 'none'} }} style={style}>
            <Stepper activeStep={activeStep} orientation="vertical" className={useStyleObject.root}>
                {steps.map((step, index) => (
                    <Step key={step.label}>
                        <StepLabel
                            optional={
                                index === 2 ? (
                                    <Typography variant="caption">Last step</Typography>
                                ) : null
                            }
                        >
                            {step.label}
                        </StepLabel>
                        <StepContent >
                           <Box >
                               <RowRadioButtonsGroup labels={step.options} />
                               <Box sx={{ mb: 2 }}>
                                   <div>
                                       <Button
                                           variant="contained"
                                           onClick={handleNext}
                                           sx={{ mt: 1, mr: 1 , backgroundColor: '#DE5103', textTransform: 'lowercase',
                                               fontSize: 12, '&:hover': {
                                                   backgroundColor: '#de5103'
                                               }}}
                                       >
                                           {index === steps.length - 1 ? 'Search' : 'Continue'}
                                       </Button>
                                       <Button
                                           onClick={handleBack}
                                           sx={{ mt: 1, mr: 1, display: `${index === 0 ? 'none' : 'inline'}` , color: '#DE5103'}}
                                       >
                                           Back
                                       </Button>
                                   </div>
                               </Box>
                           </Box>
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
            {activeStep === steps.length && (
                <Paper square elevation={0} sx={{ p: 3 }}>
                    <CircularProgress color='secondary'/>
                    <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
                        Reset
                    </Button>
                </Paper>
            )}
        </Box>
    );
}